export enum RolesEnum {
  OLD_NEVRON_SUPERADMIN = 'Super Admin',
  NEVRON_SUPERADMIN = 'Nevron Superadmin',
  OPERATOR_SUPERADMIN = 'Operator Superadmin',
  PROJECT_ADMIN = 'Project Admin'
}
